<template>
  <div class="container">
    <div class="main-card">
      <div class="header-section">
        <h1 class="main-title">Gestione Credito</h1>
        <p class="subtitle">Accedi alle funzionalità di gestione credito</p>
      </div>

      <div class="actions-grid">
        <div class="action-card credito-card" @click="navigateToCreditoDaGestire">
          <div class="card-icon credito-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
          <h3 class="card-title">Credito Da Gestire</h3>
          <p class="card-description">Fatture Scadute da più di 31 gg,<br>solo domestici.</p>
          <div class="card-arrow">→</div>
        </div>

        <div class="action-card privilegiati-card" @click="navigateToCreditoDaGestirePrivilegiati">
          <div class="card-icon privilegiati-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="8.5" cy="7" r="4" />
              <path d="m22 2-5 10-3-3-2 2" />
            </svg>
          </div>
          <h3 class="card-title">Credito Da Gestire Business + ex logica privilegiati</h3>
          <p class="card-description">Gestione credito clienti Business + ex logica privilegiati</p>
          <div class="card-arrow">→</div>
        </div>
      </div>

      <div class="footer-section">
        <div class="info-banner">
          <p>💡 Clicca per accedere alla gestione del credito</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditoView',
  methods: {
    navigateToCreditoDaGestire() {
      this.$router.push('/credito-da-gestire');
    },
    navigateToCreditoDaGestirePrivilegiati() {
      this.$router.push('/credito-da-gestire-business');
    }
  }
}
</script>

<style scoped>
.container {
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
}

.header-section {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.5rem 0;
  background: #0d3c61;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.main-title:hover .main-title {
  color: white;
}


.subtitle {
  font-size: 1.1rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  justify-content: center;
  margin-bottom: 2rem;
}

.action-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.action-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border-color: transparent;
}

.credito-card:hover {
  background: linear-gradient(135deg, #0d3c61, #215159, #3288b3);
  color: white;
}

.privilegiati-card:hover {
  background: linear-gradient(135deg, #7c3aed, #a855f7, #c084fc);
  color: white;
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
}

.credito-icon {
  background: linear-gradient(135deg, #0d3c61, #215159, #3288b3);
  color: white;
}

.privilegiati-icon {
  background: linear-gradient(135deg, #7c3aed, #a855f7, #c084fc);
  color: white;
}

.action-card:hover .card-icon {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #1a202c !important;
  background: none !important;
  background-color: transparent !important;
  -webkit-background-clip: initial !important;
  -webkit-text-fill-color: initial !important;
  background-clip: initial !important;
  font-family: 'Montserrat', sans-serif !important;
  transition: color 0.3s ease;
}

.card-description {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
  font-family: 'Montserrat', sans-serif !important;
  transition: color 0.3s ease;
}

.action-card:hover .card-title,
.action-card:hover .card-description {
  color: white !important;
}

.card-arrow {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  opacity: 0;
  transition: all 0.3s ease;
  color: white;
}

.action-card:hover .card-arrow {
  opacity: 1;
  transform: translateX(5px);
}

.footer-section {
  margin-top: 2rem;
}

.info-banner {
  background: linear-gradient(135deg, #e0e7ff, #f0f9ff);
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  text-align: center;
}

.info-banner p {
  margin: 0;
  color: #3730a3;
  font-weight: 500;
}

@media (max-width: 768px) {
  .container {
    padding: 1rem;
  }

  .main-card {
    padding: 2rem;
  }

  .main-title {
    font-size: 2rem;
  }

  .actions-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .action-card {
    min-height: 140px;
    padding: 1.5rem;
  }

  .card-icon {
    width: 50px;
    height: 50px;
  }

  .card-title {
    font-size: 1.1rem;
  }

  .card-description {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .main-card {
    padding: 1.5rem;
    border-radius: 16px;
  }

  .main-title {
    font-size: 1.75rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .action-card {
    min-height: 120px;
    padding: 1.25rem;
  }
}
</style>